export default __webpack_public_path__ + "static/media/jenny-roderick-untermyergarden-palma-wedding-164_tn.5110fd73.jpg";